import { Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { HttpDataService, Cache } from 'core/index';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class GroupLogService extends HttpDataService {
  protected reportData: Cache;
  public groupId: string;
  public date: string;

  constructor(protected injector: Injector) {
    super(injector, '/core');
  }

  resolve(route: ActivatedRouteSnapshot): Promise<any> {
    const groupId = route.paramMap.get('groupId');
    if (groupId) {
      return this.loadReportData(groupId);
    }
    return Promise.reject('group id not found');
  }

  loadReportData(groupId: string, date?: string): Promise<any> {
    this.date = date;
    this.groupId = groupId;
    return this.getReportData(groupId, date).then((reportData) => {
      this.reportData = new Cache(reportData);
      return this.reportData;
    });
  }

  fetch(options?: any): Promise<any> {
    if (options.date !== this.date || this.groupId !== options.groupId) {
      return this.loadReportData(options.groupId, options.date).then(() => this.reportData.fetch(options));
    }
    return this.reportData.fetch(options);
  }

  getReportData(groupId: string, date?: string): Promise<any> {
    const url = `${this.baseUrl}/groups/${groupId}/reports`;
    return lastValueFrom(this.http.get(url, this.getRequestOptions(date ? { date } : null)))
      .then((response) => response)
      .catch((error) => this.handlePromiseError(error));
  }
}
